module.exports = __webpack_public_path__ + "static/media/NotoSansCJKtc-Light.9807320a.svg";